"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PUBMED_RSS_REQUIRES_SEARCH_QUERY = void 0;
exports.isPubMedRssFeedUrl = isPubMedRssFeedUrl;
/** PubMed RSS feeds are served from this host (E-utilities batching applies when `pubmedTerm` is also set). */
function isPubMedRssFeedUrl(feedUrl) {
    try {
        return new URL(feedUrl.trim()).hostname === "pubmed.ncbi.nlm.nih.gov";
    }
    catch {
        return false;
    }
}
/** NCBI blocks server-side scraping of PubMed RSS URLs; E-utilities requires `pubmedTerm`. */
exports.PUBMED_RSS_REQUIRES_SEARCH_QUERY = "PubMed RSS feeds require an Advanced Search Query. NCBI blocks direct RSS fetching from server environments — use the Search Query field with a PubMed advanced search term.";
